import 'babel-polyfill'

import Vue from 'vue'
import ElementUI from '@supaur/element-ui-rtl'
import VueStorage from 'vue-ls'
import '@supaur/element-ui-rtl/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store'
import '@/icons' // icon
import '@/permission' // 权限
import jsencrypt from 'jsencrypt'
import { storageOptions, diffLength } from './lib/utils'

// import domainApi from '@/api/domain'
process.env.NODE_ENV === 'development' && require('./mock')
// import './mock' // 模拟数据

Vue.use(VueStorage, storageOptions)

import i18n from '@/i18n'
import dateFilter from '@/lib/filter'
// 输入框数据自动去除头尾空格
ElementUI.Input.methods.handleInput = function(event) {
  const value = event.target.value.trim()
  this.$emit('input', value)
  // this.setCurrentValue(value)
}
Vue.config.productionTip = false
Vue.filter('dateFilter', dateFilter)
Vue.prototype.$jsencrypt = new jsencrypt.JSEncrypt()
Vue.prototype.diffLength = diffLength
// console.log('domainApi', domainApi)
// })
Vue.mixin({
  computed: {
    isRtl() {
      return document.dir === 'rtl'
    }
  }
})
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})
// domainApi.getDomain().then(res => {
// domainApi.getLogo(res.data.LOGO['common']).then(res => {
//   document.title = res.title
//   const link = document.createElement('link')
//   link.rel = 'icon'
//   link.type = 'image/x-icon'
//   link.href = res.ico
//   document.head.appendChild(link)

// })
// 全局修改rlt
const langData = localStorage.getItem('sp__LANG')
if (langData !== null) {
  const lang = JSON.parse(langData)
  if (lang.value === 'ar-sa') {
    document.dir = 'rtl'
  } else {
    document.dir = 'ltr'
  }
}



// WEBPACK FOOTER //
// ./src/main.js